
<template #chartComponent></template>
@if(NO_DATA){
  <ng-container>
    <div class="d-flex justify-content-center place-self-center">
        <img src="assets/images/nodata.png" style="width: 250px;" alt="no data" />
    </div>
  </ng-container>
}


@if(NO_DATA_ALLOWED){
  <ng-container>
    <div class="d-flex justify-content-center place-self-center">
      <p class="alert alert-danger text-center" style="position: absolute; top: 50%; transform: translateY(-50%); font-size: 12px;">
        <span i18n="@@noDataAllowed" class="ml-2">Este panel no está disponible por falta de permisos</span>
      </p>
    </div>
  </ng-container>
}

@if(NO_FILTER_ALLOWED){
  <ng-container>
    <div class="d-flex justify-content-center place-self-center">
      <p class="alert alert-danger text-center" style="position: absolute; top: 50%; transform: translateY(-50%); font-size: 12px;">
        <span i18n="@@noFilterAllowed" class="ml-2">Este panel no está disponible por falta de permisos en un filtro</span>
      </p>
    </div>
  </ng-container>
}